function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import AsyncLoader from "./AsyncLoader";
export default (({
  asyncDataProps,
  errorScreen,
  children
}) => React.useMemo(() => {
  if (asyncDataProps && typeof children === "function") {
    return /*#__PURE__*/React.createElement(AsyncLoader, _extends({}, asyncDataProps, {
      errorScreen: errorScreen
    }), children);
  } else if (typeof children === "function") {
    return children();
  }

  return children;
}, [asyncDataProps, children, errorScreen]));